import { PossibleWinningAboveWinTreshold } from '../types';

export const possibleWinningAboveWinTresholdMode: PossibleWinningAboveWinTreshold = 'usa';
